module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bill-check"
  }, [_c('Modal', {
    staticClass: "bill-check-modal",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "width": "700",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../images/bill-check-modal-icon.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 25px"
    }
  }, [_c('p', {
    staticClass: "text title"
  }, [_vm._v("尊敬的客户您好:")]), _vm._v(" "), (_vm.message) ? _c('p', {
    staticClass: "text"
  }, [_vm._v("· " + _vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.alertText) ? _c('p', {
    staticClass: "text"
  }, [_vm._v("\n      " + _vm._s(_vm.alertText) + "\n      "), _c('span', {
    staticClass: "info"
  }, [_vm._v("(未确认"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.billNum))]), _vm._v("条)")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "text-decoration": "underline",
      "color": "#ff9900",
      "font-size": "14px",
      "padding": "0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleCheckBill
    }
  }, [_vm._v("前往确认")]), _vm._v(" "), _c('span', [_vm._v("。")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [(_vm.overdueDays < 5 && _vm.allowBooking) ? _c('Button', {
    staticStyle: {
      "width": "142px",
      "height": "38px",
      "font-size": "18px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.handlePlaceOrder
    }
  }, [_vm._v("立即下单")]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4db33d2f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4db33d2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/bill-check-modal.vue
// module id = 1361
// module chunks = 61